export default {
    initEnvironment: env => {
        return {
            url: `/${env}/initialize`,
            method: 'GET'
        };
    },
    getNewProductsDetails: (env, homeId, productType, productIdentifier) => {
        return {
            url: `/${env}/getNewProduct/:homeId/:productType/:productIdentifier`,
            method: 'GET',
            route_params: {
                homeId,
                productType,
                productIdentifier
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/api.js